// Fee resolution helpers for the customer-facing pricing pipeline.
//
// Mirrors the backend's COALESCE pattern at backend/routes/bookings.js:765
// — the trailer's per-row override (when set) wins over the business-wide
// default. Customer-facing display previously used the business default
// only, so customers were quoted prices that diverged from the system of
// record (the backend correctly stored the override on the booking row).

// Returns the trailer's override when it parses to a finite number;
// otherwise the business default; otherwise the hard-coded fallback.
// Use for cleaning_fee and security_deposit_amount in any component that
// renders price estimates on /trailer/:id and /book/:id.
export function resolveTrailerFee(trailerValue, settingsValue, fallback) {
  const t = parseFloat(trailerValue);
  if (Number.isFinite(t)) return t;
  const s = parseFloat(settingsValue);
  return Number.isFinite(s) ? s : fallback;
}
